module.exports = __webpack_public_path__ + "img/2-top.ea41903a.svg";